import { Form, Formik } from 'formik'
import React from 'react'
import styled from 'styled-components'
import * as Yup from 'yup'
import Button from '../../../../../components/buttons/buttons.component'
import {
	SelectInput,
	TextInput
} from '../../../../../components/form-components/inputs.component'

import { routes } from '../../../../../constants/routes.constants'
import StyledFlexContainer from './../../../../../components/containers/flex-container.component'

const StyledButtonContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	padding-top: 2.7rem;
`

const schema = Yup.object().shape({})

class SearchForm extends React.Component {
	constructor(props) {
		super(props)

		this.goToAddPage = goToAddPage.bind(this)
	}

	render() {
		const { onSubmit } = this.props
		return (
			<div>
				<Formik
					initialValues={{
						active: '',
						name: ''
					}}
					onSubmit={onSubmit}
					validationSchema={schema}
					render={props => (
						<Form className="form" noValidate>
							<StyledFlexContainer>
								<TextInput
									className={'col-10'}
									autoFocus={true}
									maxLength={128}
									label={'Nome'}
									id={'name'}
									{...props}
								/>
								<SelectInput
									defaultValue={{ value: true, label: 'Ativos' }}
									options={statusOptions}
									className={'col-2'}
									label={'Situação'}
									multi={false}
									id="active"
									{...props}
								/>
							</StyledFlexContainer>
							<StyledButtonContainer>
								<Button
									style={{ marginRight: '15px' }}
									onClick={this.goToAddPage}
									type={'button'}
									secondary
									data-permission="E5FE2D372B8F04019776C09A06952300B95796D9">
									Novo
								</Button>
								<Button
									data-permission="E2DBE8A95933AFBC05AE2B3B04B006C5B42B5A0B"
									primary
									type="submit">
									Consultar
								</Button>
							</StyledButtonContainer>
						</Form>
					)}
				/>
			</div>
		)
	}
}

function goToAddPage() {
	this.props.history.push(`${routes.ADMIN}/loja-moveflex/novo-produto`)
}

const statusOptions = [
	{ value: '', label: 'Todos' },
	{ value: true, label: 'Ativos' },
	{ value: false, label: 'Inativos' }
]

export default SearchForm
